require('cropper');
require('./files/add-to-cart-personalized');
require('./files/description');
require('./files/portrait');
require('./files/reviews');

require('../../css/web/add-to-cart.css');
require('../../css/web/reviews.css');
require('../../css/web/tabs.css');
require('../../css/web/table-color.css');
require('../../css/web/services.css');
require('../../css/web/portrait.css');
require('cropper/dist/cropper.min.css');
require('../../sass/web/personalized_services.scss');
require('../../sass/web/review.scss');